import React, { useState, useRef, useEffect } from 'react'
import presets from '../../styles/media'
import styled from 'styled-components'

const App = ({ src, children }) => {
	const videoElement = useRef(null)
	const [isPlaying, setIsPlaying] = useState(false)
	const [progress, setProgress] = useState(0)

	// check if mobile
	const [isDesktop, setIsDesktop] = useState(false)
	useEffect(() => {
		setIsDesktop(window.innerWidth > presets.BREAKPOINT_DESKTOP)
	}, [])

	// controls
	const togglePlay = () => {
		setIsPlaying(prev => !prev)
	}

	useEffect(() => {
		isPlaying ? videoElement.current.play() : videoElement.current.pause()
	}, [isPlaying, videoElement])

	const handleOnTimeUpdate = () => {
		const progress =
			(videoElement.current.currentTime / videoElement.current.duration) *
			100
		setProgress(progress)
	}

	const handleVideoProgress = event => {
		const manualScrubbing = Number(event.target.value)
		videoElement.current.currentTime =
			(videoElement.current.duration / 100) * manualScrubbing
		setProgress(manualScrubbing)
	}

	return src ? (
		<Wrapper>
			<Inner>
				<video
					src={src}
					ref={videoElement}
					onTimeUpdate={handleOnTimeUpdate}
					controls={!isDesktop}
				/>
				{isDesktop && (
					<Controls isPlaying={isPlaying}>
						<PlayPause onClick={togglePlay}>
							{isPlaying ? (
								<svg
									width="13"
									height="16"
									viewBox="0 0 13 16"
									fill="none"
								>
									<path
										d="M0 1C0 0.447715 0.447715 0 1 0H4C4.55228 0 5 0.447715 5 1V15C5 15.5523 4.55228 16 4 16H1C0.447715 16 0 15.5523 0 15V1Z"
										fill="rgb(255,255,255)"
									/>
									<path
										d="M8 1C8 0.447715 8.44772 0 9 0H12C12.5523 0 13 0.447715 13 1V15C13 15.5523 12.5523 16 12 16H9C8.44772 16 8 15.5523 8 15V1Z"
										fill="rgb(255,255,255)"
									/>
								</svg>
							) : (
								<svg
									width="14"
									height="16"
									viewBox="0 0 14 16"
									fill="none"
								>
									<path
										d="M13.3636 6.88212C14.2121 7.37896 14.2121 8.62104 13.3636 9.11788L1.90909 15.8251C1.06061 16.322 -4.2826e-08 15.7009 0 14.7073L5.78153e-07 1.29274C6.2098e-07 0.29907 1.06061 -0.321972 1.90909 0.174862L13.3636 6.88212Z"
										fill="rgb(255,255,255)"
									/>
								</svg>
							)}
						</PlayPause>
						<Seek
							type="range"
							min="0"
							max="100"
							value={progress}
							onChange={e => handleVideoProgress(e)}
						/>
					</Controls>
				)}
			</Inner>
			{children && (
				<figcaption dangerouslySetInnerHTML={{ __html: children }} />
			)}
		</Wrapper>
	) : (
		console.error('No video src.')
	)
}

const Controls = styled.div.attrs(props => ({
	style: {
		transform: props.isPlaying ? 'translateY(150%)' : 'translateY(0)',
		opacity: props.isPlaying ? '0' : '1',
	},
}))`
	position: absolute;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: space-evenly;
	width: 100%;
	padding: 0.25rem;
	background: rgba(0, 0, 0, 0.25);
	border: 1px solid rgba(0, 0, 0, 0.1);
	border-radius: 0.5rem;
	backdrop-filter: blur(0.5rem);
	transition: transform 0.3s ease-in-out, opacity 0.2s ease-in-out;

	${presets.desktop} {
		bottom: 2rem;
		max-width: 50%;
	}
`

const Wrapper = styled.figure`
	width: 100%;

	/* line-height: 0; */

	&:hover ${Controls} {
		transform: translateY(0) !important;
		opacity: 1 !important;
	}

	& video {
		background: #eee;
	}

	& figcaption {
		padding: 0.75rem 0.25rem;
		line-height: 1.4;
		color: var(--color-text-tertiary);
	}

	${presets.desktop} {
		min-height: 360px;

		& figcaption {
			max-width: 75%;
			margin: 0 auto;
			text-align: center;
		}
	}
`

const Inner = styled.div`
	width: 100%;
	height: 100%;
	position: relative;
	display: flex;
	justify-content: center;
`

const PlayPause = styled.button`
	display: flex;
	flex-shrink: 0;
	align-items: center;
	justify-content: center;
	width: 2rem;
	height: 2rem;
	margin-right: 0.5rem;
	background: none;
	border: none;
	cursor: pointer;
	appearance: none !important;
	border-radius: 100%;
`
const Seek = styled.input`
	width: 100%;
	background: none;
`

export default App
